import { createApp } from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/aos-fixed.css'
import AOS from 'aos'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { ApmVuePlugin } from '@elastic/apm-rum-vue'
import number, { options } from '@coders-tm/vue-number-format'
import firebaseMessaging from './firebase'
import Toast, { POSITION } from 'vue-toastification'
import vue3GoogleLogin from 'vue3-google-login'
import { Vue3ProgressPlugin } from '@marcoschulte/vue3-progress'
import tooltipDirective from '@/directives/tooltip'

let app = createApp(App)
app.directive('tooltip', tooltipDirective)

app.config.globalProperties.$messaging = firebaseMessaging
app.config.globalProperties.$apiKey = process.env.VUE_APP_API_BUDGETY_KEY
app.config.globalProperties.$formatterMoney = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
})

app.config.globalProperties.$formatterMoneyCurrency = function (monto, currency = 'CLP') {
  let formattedMonto
  // Mapeo específico de 'CLF' a 'UF'
  if (currency === 'CLF') {
    formattedMonto = `UF ${new Intl.NumberFormat('es-CL', options).format(monto)}`
  } else {
    const options = {
      style: 'currency',
      currency,
    }
    formattedMonto = new Intl.NumberFormat('es-CL', options).format(monto)
  }
  return formattedMonto
}

app
  .use(store)
  .use(Vuex)
  .use(router)
  .use(Toast, {
    // You can set your default options here
    transition: 'Vue-Toastification__bounce',
    maxToasts: 20,
    newestOnTop: true,
    timeout: 5000,
  })
  .use(number, {
    decimal: ',',
    separator: '.',
    prefix: '$',
    suffix: '',
    precision: 2,
    min: 1,
    max: 99999999999,
  })
  .use(vue3GoogleLogin, {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  })
  .use(Vue3ProgressPlugin)
  .use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
    loaderOptions: {
      useRecaptchaNet: true,
    },
  })
  .mount('#app')

if (process.env.VUE_APP_ELASTIC_IS_ACTIVE !== 'false') {
  app.use(ApmVuePlugin, {
    router,
    config: {
      serviceName: process.env.VUE_APP_ELASTIC_SERVICE_NAME,
      serverUrl: process.env.VUE_APP_ELASTIC_SERVER_HOST,
      logLevel: process.env.VUE_APP_ELASTIC_LOG_LEVEL,
      secretToken: process.env.VUE_APP_ELASTIC_TOKEN,
      environment: process.env.VUE_APP_ELASTIC_ENVIROMENT,
      transactionSampleRate: 0.5,
    },
  })
}

AOS.init()
